(function () {
  if (!window.klaviyo) {
    window._klOnsite = window._klOnsite || [];
    try {
      window.klaviyo = new Proxy(
        {},
        {
          get(n, i) {
            if (i === 'push') {
              return function () {
                window._klOnsite.push.apply(window._klOnsite, arguments);
              };
            }
            return function () {
              const args = Array.from(arguments);
              const callback = typeof args[args.length - 1] === 'function' ? args.pop() : undefined;
              return new Promise((resolve) => {
                window._klOnsite.push([i].concat(args, [function (result) {
                  if (callback) callback(result);
                  resolve(result);
                }]));
              });
            };
          },
        }
      );
    } catch (error) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = function () {
        window._klOnsite.push.apply(window._klOnsite, arguments);
      };
    }
  }

  const config = window.theme?.klaviyo;
  if (!config) return;

  function getClient() {
    return window.klaviyo || [];
  }

  function track(event, properties) {
    const client = getClient();
    if (typeof client.track === 'function') {
      client.track(event, properties);
      return;
    }
    client.push(['track', event, properties]);
  }

  function identify(properties) {
    const client = getClient();
    if (typeof client.identify === 'function') {
      client.identify(properties);
      return;
    }
    client.push(['identify', properties]);
  }

  function formatPrice(cents) {
    return typeof cents === 'number' ? cents / 100 : 0;
  }

  function absoluteUrl(path) {
    if (!path) return config.shopUrl;
    if (path.startsWith('http')) return path;
    return `${config.shopUrl}${path.startsWith('/') ? path : `/${path}`}`;
  }

  function variantImageUrl(variant, fallbackImage) {
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (typeof variant?.featured_image === 'string') return variant.featured_image;
    if (variant?.image) return absoluteUrl(variant.image);
    return fallbackImage || '';
  }

  function buildViewedProductItem(product, variant) {
    const item = {
      ProductName: product.title,
      ProductID: String(product.id),
      SKU: variant?.sku || '',
      Categories: product.categories || [],
      ImageURL: variantImageUrl(variant, product.image),
      URL: absoluteUrl(product.url) + (variant?.id ? `?variant=${variant.id}` : ''),
      Brand: product.vendor || '',
      Price: formatPrice(variant?.price),
    };

    if (variant?.compare_at_price) {
      item.CompareAtPrice = formatPrice(variant.compare_at_price);
    }

    return item;
  }

  function trackViewedProduct(product, variant) {
    if (!product || !variant) return;

    const item = buildViewedProductItem(product, variant);
    track('Viewed Product', item);

    const client = getClient();
    if (typeof client.trackViewedItem === 'function') {
      client.trackViewedItem({
        Title: item.ProductName,
        ItemId: item.ProductID,
        Categories: item.Categories,
        ImageUrl: item.ImageURL,
        Url: item.URL,
        Metadata: {
          Brand: item.Brand,
          Price: item.Price,
          CompareAtPrice: item.CompareAtPrice,
        },
      });
    }
  }

  function mapCartLineItem(lineItem) {
    const image = lineItem.image
      ? lineItem.image.startsWith('http')
        ? lineItem.image
        : `https:${lineItem.image}`
      : '';

    return {
      ProductID: String(lineItem.product_id),
      SKU: lineItem.sku || '',
      ProductName: lineItem.product_title || lineItem.title,
      Quantity: lineItem.quantity,
      ItemPrice: formatPrice(lineItem.price),
      RowTotal: formatPrice(lineItem.final_line_price ?? lineItem.line_price),
      ProductURL: absoluteUrl(lineItem.url),
      ImageURL: image,
      ProductCategories: lineItem.product_type ? [lineItem.product_type] : [],
    };
  }

  function buildAddedToCartPayload(addedItem, cart) {
    const items = (cart.items || []).map(mapCartLineItem);
    const itemNames = items.map((item) => item.ProductName);
    const categories = items.flatMap((item) => item.ProductCategories);
    const addedImage = addedItem.image
      ? addedItem.image.startsWith('http')
        ? addedItem.image
        : `https:${addedItem.image}`
      : '';

    const payload = {
      $value: formatPrice(cart.total_price),
      AddedItemProductName: addedItem.product_title || addedItem.title,
      AddedItemProductID: String(addedItem.product_id),
      AddedItemSKU: addedItem.sku || '',
      AddedItemCategories: addedItem.product_type ? [addedItem.product_type] : [],
      AddedItemImageURL: addedImage,
      AddedItemURL: absoluteUrl(addedItem.url),
      AddedItemPrice: formatPrice(addedItem.price),
      AddedItemQuantity: addedItem.quantity,
      ItemNames: itemNames,
      CheckoutURL: absoluteUrl('/checkout'),
      Items: items,
    };

    if (categories.length) {
      payload.AddedItemCategories = [...new Set(categories)];
    }

    return payload;
  }

  if (config.customerEmail) {
    identify({ $email: config.customerEmail });
  }

  if (config.product?.variant) {
    trackViewedProduct(config.product, config.product.variant);
  }

  document.addEventListener('variant-change', (event) => {
    const variant = event.detail?.variant;
    if (!variant || !config.product) return;
    trackViewedProduct(config.product, variant);
  });

  document.addEventListener('cart-add', (event) => {
    const addedItem = event.detail?.cartData;
    if (!addedItem || addedItem.status) return;

    fetch(config.cartJsUrl, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        track('Added to Cart', buildAddedToCartPayload(addedItem, cart));
      })
      .catch((error) => {
        console.error('Klaviyo Added to Cart tracking failed', error);
      });
  });
})();
